import z from 'zod';

import { ApprovalItems, FetchedApprovalTypes } from './enums.js';

export const fetchedApprovalTypesSchema = z.enum(FetchedApprovalTypes);
export const approvalItemsTypesSchema = z.enum(ApprovalItems);

const formSelectDataSchema = z.object({
  id: z.string(),
  userName: z.string().nullable().prefault(null),
  role: z.string(),
});

export const approvalTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: fetchedApprovalTypesSchema,
  operation: z.string().nullable().optional(),
  role: formSelectDataSchema.nullable().optional(),
  users: z.array(formSelectDataSchema).nullable().optional(),
});

export type ApprovalType = z.infer<typeof approvalTypeSchema>;

export const approvalFlowsSchema = z.array(
  z.object({
    approval: z.array(approvalTypeSchema),
    approvalItems: z.array(approvalItemsTypesSchema),
    createdAt: z.string(),
    id: z.string(),
    name: z.string(),
    notificationPeriod: z.number().nullable().optional(),
    requestGroup: z.object({
      id: z.string(),
      roles: z.array(formSelectDataSchema).nullable().optional(),
      users: z.array(formSelectDataSchema).nullable().optional(),
    }),
  }),
);

export type ApprovalFlows = z.infer<typeof approvalFlowsSchema>;
export type ApprovalFlow = ApprovalFlows[0];

export const statusSchema = z.object({
  userStatus: z.union([
    z.literal('requestor'),
    z.literal('approver'),
    z.literal('stranger'),
  ]),
  approvalProcessId: z.string().nullable(),
  approvalItemStatus: z
    .union([
      z.literal('draft'),
      z.literal('progress'),
      z.literal('rejected'),
      z.literal('approved'),
    ])
    .nullable(),
  userDecision: z.string().nullable(),
});

export type ApprovalFlowsStatusData = z.infer<typeof statusSchema>;

export const changeApprovalProcessSchema = z.object({
  id: z.string(),
  approvalFlowId: z.string(),
  startedAt: z.string(),
  ссEmails: z.array(z.string()).optional(),
  requestor: z.object({
    id: z.string(),
    userId: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    comment: z.string(),
  }),
  approvalItem: z.object({
    id: z.string(),
    approvalItemId: z.string(),
    type: z.string(),
    name: z.string(),
    campaignName: z.string(),
    dateFrom: z.string(),
    dateTo: z.string(),
    campaignBudget: z.number(),
    plannedBudget: z.number(),
    netMediaBudget: z.number().optional(),
  }),
});

// More details
export const UserDataSchema = z.object({
  id: z.number(),
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
});

export const getMoreDetailsSchema = z.object({
  id: z.string(),
  approvalType: z.enum(['users', 'roles', 'operation']),
  name: z.string(),
  user: UserDataSchema.nullable(),
  operation: z.enum(['and', 'then', 'or']).nullable(),
  updatedAt: z.string(),
  comment: z.string().prefault(''),
  status: z
    .enum(['inactive', 'progress', 'approved', 'rejected'])
    .prefault('progress'),
  approvers: z.array(z.unknown()),
  sentAt: z.string().nullable(),
  canBeReminded: z.boolean().prefault(false),
});

export type GetMoreDetailsResponse = z.infer<typeof getMoreDetailsSchema>;
